import classNames from "classnames";
import PropType from "prop-types";
import styles from "./TabMenu.module.scss";

const TabTitle = ({ id, panelId, displayTitle, category, active, onChange }) => {
  const handleKeyDown = e => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onChange(e, category?.value);
    }
  };

  return (
    <div
      role="tab"
      id={id}
      aria-controls={panelId}
      tabIndex={active ? 0 : -1}
      aria-selected={active}
      onClick={e => onChange(e, category?.value)}
      onKeyDown={handleKeyDown}
      className={classNames(styles.title, active && styles.active)}
    >
      {displayTitle ?? category?.label}
    </div>
  );
};

TabTitle.propTypes = {
  id: PropType.string,
  panelId: PropType.string,
  displayTitle: PropType.string,
  category: PropType.object,
  active: PropType.bool,
  onChange: PropType.func,
};

export default TabTitle;
